import React, { useState } from 'react';
import { Link } from "react-router-dom";

// third-party
import { BsStars, BsCopy, BsCheck } from "react-icons/bs";
import { showToast } from '../../sweet-alert/Sweetalert';
import { GoogleAnalyticsEnum, triggerFunction } from '../../../utils/google-analytics';
import { toUpperSnake } from '../../../utils';

const AISummaryBox = ({ data, currentSeries, error, classes }) => {
    // State initialization
    const [copied, setCopied] = useState(false);

    // handle functions
    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(data);
            setCopied(true);
            showToast(
                "success",
                `AI summary copied.`,
                true,
                "top",
                false,
                true,
                5000
            );
            setTimeout(() => setCopied(false), 2000);
            triggerFunction(
                GoogleAnalyticsEnum.BUTTON,
                GoogleAnalyticsEnum.COPIED_AI_SUMMARY + `_FROM_SERIES_${toUpperSnake(currentSeries.toString())}`)
        } catch (error) {
            console.error('33 : AISummaryBox : Failed to copy text: ', error);
        }
    };

    return (
        <div className={`edu-blog-widget  widget-about ai-summary-card ${classes ? classes : ""}`}>
            <div className="inner">
                <div className="ai-summary-header">
                    <div className='d-flex align-items-center gap-2'>
                        <BsStars className="ai-icon" />
                        <span className='fs-17'>AI Summary</span>
                    </div>
                    {/* <div>
                        {copied ? <BsCheck className="w-4 h-4 text-green-600 " /> : <BsCopy
                            onClick={handleCopy}
                            rel="noreferrer"
                            className='clickable'
                        >
                        </BsCopy>}
                    </div> */}

                </div>

                <div class="our-mission">
                    <div class="section-title text-start">

                        <ul class="list-style-3">
                            {data?.map((item, i) => {
                                return (
                                    <li className="p-0 mb--0 fs-15">
                                        <i class="ri-check-line"></i>
                                        <p>
                                            {item || ""}
                                        </p>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default AISummaryBox;